<script setup>
import { useRequestsStore } from "@/stores/storeRequests";
import { useModals } from "@/utils/useModals";

const { openModal } = useModals();

const storeRequests = useRequestsStore();

const formatPhoneNumber = (phone) => {
	const formattedPhoneNumber = phone?.replace(/(\d{1})(\d{3})(\d{3})(\d{2})(\d{2})/, "7 $2 $3 $4$5");
	return formattedPhoneNumber;
};
</script>
<template>
	<div class="user-data">
		<div class="user-data__holder">
			<h1 class="user-data__title">Личные данные</h1>
			<div class="user-data__inner">
				<div class="user-data__contacts">
					<span>{{ storeRequests.userData?.first_name }} {{ storeRequests.userData?.last_name }}</span>
					<span>{{ formatPhoneNumber(storeRequests.userData?.phone_number) }}</span>
					<span>{{ storeRequests.userData?.email }}</span>
				</div>
				<div class="user-data__btns">
					<button @click="openModal('changeUserProfile')" class="user-data__btn btn --border-grey --small">Изменить данные</button>
					<button @click="openModal('changeUserPassword')" class="user-data__btn btn --border-grey --small">Изменить пароль</button>
				</div>
			</div>
		</div>
	</div>
</template>
<style lang="scss" scoped>
@use "@/assets/scss/base/vars";

.user-data {
	padding: 5rem 0 8.3rem;
	display: flex;
	justify-content: center;
    @media (max-width: vars.$x480) {
        padding: 3.5rem 0 5rem;
    }
}
.user-data__holder {
	max-width: 120rem;
	width: 100%;
	border-radius: var(--border-radius);
	padding: 4.7rem 6.3rem 5.6rem;
	background-color: #fff;
    @media (max-width: vars.$x480) {
        padding: 3.6rem 2.2rem 4.2rem;

    }
}
.user-data__title {
	font-weight: 700;
	font-size: 4rem;
	line-height: 140%;
	text-transform: uppercase;
	color: #0c4ca3;
	margin-bottom: 1.8rem;
	@media (max-width: vars.$x480) {
		font-size: 2rem;
	}
}
.user-data__inner {
	display: flex;
	align-items: center;
	justify-content: space-between;
    gap: 1rem;
    @media (max-width: vars.$xx) {
        flex-direction: column;
        align-items: start;
        gap: 4rem;
    }
}
.user-data__contacts {
	display: grid;
	gap: 0.8rem;
	font-weight: 400;
	font-size: 2.4rem;
	line-height: 140%;
    @media (max-width: vars.$x480) {
        font-size: 1.6rem;
        gap: 0px;
    }
	span {
		// &:first-child {
		//     display: flex;
		//     align-items: center;
		//     gap: 2rem;
		//     @media (max-width: vars.$x480) {

		//     }
		//     &::after {
		//         content: '';
		//         width: 0.4rem;
		//         height: 0.4rem;
		//         border-radius: 100%;
		//         background-color: #000;
		//         @media (max-width: vars.$x480) {
		//             display: none;
		//         }
		//     }
		// }
	}
}
.user-data__btns {
	display: grid;
	gap: 2.4rem;
	max-width: 280px;
    @media (max-width: vars.$xx) {
        max-width: 100%;
        width: 100%;
        gap: 1.5rem;
    }
}
.user-data__btn {
	padding-left: 3rem;
    padding-right: 3rem;
    @media (max-width: vars.$xx) {
        width: 100%;
    }
	@media (max-width: vars.$x480) {
		font-size: 2rem;
	}
}
</style>
